import Navbar from "../components/site/Navbar";
import HeroQuote from "../components/site/HeroQuote";
import TabsSection from "../components/site/TabsSection";
import Footer from "../components/site/Footer";

export default function Landing() {
    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen bg-[#050505] text-white overflow-x-hidden"
        >
            <Navbar />
            <HeroQuote />
            <TabsSection />
            <Footer />
        </main>
    );
}
